import { AppNotification, NotificationListItem } from '../models/notification-api.models';

export function capitalizeFirstLetter(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function mapNotificationFromApi(raw: Record<string, unknown>): AppNotification {
  const type = (raw['notificationType'] as Record<string, unknown>) ?? {};
  return {
    id: String(raw['id'] ?? ''),
    title: capitalizeFirstLetter(String(raw['title'] ?? '')),
    content: String(raw['content'] ?? ''),
    read: Boolean(raw['read']),
    sent: raw['sent'] as boolean | undefined,
    cause: raw['cause'] as string | undefined,
    sendingDate: String(raw['sendingDate'] ?? new Date().toISOString()),
    createdAt: String(raw['createdAt'] ?? new Date().toISOString()),
    updatedAt: String(raw['updatedAt'] ?? new Date().toISOString()),
    notificationType: {
      id: String(type['id'] ?? ''),
      intitule: String(type['intitule'] ?? ''),
      imageId: type['imageId'] as string | undefined,
      read: type['read'] as boolean | undefined,
      createdAt: type['createdAt'] as string | undefined,
      updatedAt: type['updatedAt'] as string | undefined,
    },
  };
}

export function getNotificationIcon(notification: AppNotification): string {
  const label = `${notification.notificationType.intitule} ${notification.title}`.toLowerCase();
  if (label.includes('retrait')) return 'atm';
  if (label.includes('envoi')) return 'send';
  if (label.includes('paiement') || label.includes('service')) return 'smartphone';
  if (label.includes('depot') || label.includes('dépôt')) return 'payments';
  if (label.includes('achat')) return 'shopping_cart';
  if (label.includes('virement')) return 'swap_horiz';
  return 'notifications';
}

export function getNotificationIconColor(notification: AppNotification): string {
  const label = `${notification.notificationType.intitule} ${notification.title}`.toLowerCase();
  if (label.includes('retrait')) return 'var(--color-info)';
  if (label.includes('envoi')) return 'var(--color-secondary)';
  if (label.includes('paiement') || label.includes('service')) return 'var(--color-primary)';
  if (label.includes('depot') || label.includes('dépôt')) return 'var(--color-success)';
  if (label.includes('achat')) return 'var(--color-warning)';
  if (label.includes('virement')) return 'var(--color-accent-text)';
  return 'var(--color-primary)';
}

export function formatNotificationDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  return date.toLocaleDateString('fr-FR');
}

export function formatNotificationDateTime(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  const day = date.toLocaleDateString('fr-FR');
  const time = date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  return `${day} • ${time}`;
}

export function groupNotificationsByDate(notifications: AppNotification[]): NotificationListItem[] {
  const items: NotificationListItem[] = [];
  let lastDate = '';

  for (const notification of notifications) {
    const dateLabel = formatNotificationDate(notification.sendingDate);
    if (dateLabel && dateLabel !== lastDate) {
      items.push({ kind: 'date', dateLabel });
      lastDate = dateLabel;
    }
    items.push({ kind: 'notification', notification });
  }

  return items;
}

export function mergeLiveNotifications(
  paginated: AppNotification[],
  live: AppNotification[],
): AppNotification[] {
  const seen = new Set(paginated.map((n) => n.id));
  const prepend = live.filter((n) => n.id && !seen.has(n.id));
  return [...prepend, ...paginated];
}
